import { useConfigurationStore } from '@/Store/storeConfiguration';

export function isDecorInSelectedRoom(roomsOfDecor) {
    const selectedRoom = useConfigurationStore().getRoomParamByName('selectedRoomType');
    return isDecorInRoom(roomsOfDecor, selectedRoom);
}

export function isDecorInRoom(roomsOfDecor, roomKey) {
    if (!roomsOfDecor) {
        return true;
    }
    for (let item of roomsOfDecor) {
        if (item.code === roomKey) {
            return true;
        }
    }
    return false;
}
